module.exports = __webpack_public_path__ + "img/driving.ba2d6af7.svg";